import axios from "axios";
import { url } from "../Config";
import { Header } from "../Config";


export const GetProfileDetailAPI = async () => {
    try {
        const response = await axios({
            url: `${url}api/user/get-account-details`,
            method: 'GET',
            headers: Header,
        });
        return response;
    } catch (error) {
        return error;
    }
}


export const BookingHoteDetailAndImagesAPI = async () => {
    try {
        const response = await axios({
            url: `${url}api/user/get-bookings`,
            method: 'GET',
            headers: Header,
        });
        return response;

    } catch (error) {
        return error;
    }
}

export const GetUserWalletAPI = async () => {
    try {
        const response = await axios({
            url: `${url}api/wallet/get-user-wallet`,
            method: 'GET',
            headers: Header,
        });
        return response;

    } catch (error) {
        return error;
    }
}

export const GetReviewSectionAPI = async () => {
    try {
        const response = await axios({
            url: `${url}api/user/review-section`,
            method: 'GET',
            headers: Header,
        });
        console.log("response review", response)
        return response;

    } catch (error) {
        return error;
    }
}

export const GetSiteSettingAPI = async () => {
    try {
        const response = await axios({
            url: `${url}api/user/siteSetting`,
            method: 'GET',
            headers: Header,
        });
        return response;

    } catch (error) {
        return error;
    }
}


export const GetBookingHistory = async () => {
    try {
        const response = await axios({
            url: `${url}api/user/get-booking-history`,
            method: 'GET',
            headers: Header,
        });
        return response;

    } catch (error) {
        return error;
    }
}


export const GetTransactionHistory = async (filter) => {
    try {
        const response = await axios({
            url: `${url}api/wallet/get-transaction-history?filter=${filter}`,
            method: 'GET',
            headers: Header,
        });
        return response;

    } catch (error) {
        return error;
    }
}